import { Typography } from '@mui/material';
import type { PropsWithChildren } from 'react';

export const ContentParagraph = ({ children }: PropsWithChildren) => <Typography mt={2}>{children}</Typography>;
